import { render, staticRenderFns } from "./PageDetail.vue?vue&type=template&id=fd65b192&scoped=true"
import script from "./PageDetail.vue?vue&type=script&lang=js"
export * from "./PageDetail.vue?vue&type=script&lang=js"
import style0 from "./PageDetail.vue?vue&type=style&index=0&id=fd65b192&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd65b192",
  null
  
)

export default component.exports